function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import HumanIcon from 'svg/human.svg';
import layoutStyles from 'modules/Layout/components/MainLayout/MainLayout.pcss';
import messages from '../../messages';
import styles from './CgResults.pcss';
class CgResults extends React.PureComponent {
    renderLogo() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.avatar,
            children: /*#__PURE__*/ _jsx(HumanIcon, {
                className: styles.avatar__icon
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: layoutStyles.container,
            children: /*#__PURE__*/ _jsx("div", {
                className: layoutStyles.containerInner,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.root,
                        "data-testid": "family-mb-not-selected",
                        children: [
                            this.renderLogo(),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.info,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.selectFamilyMember))
                            })
                        ]
                    })
                })
            })
        });
    }
}
export default withStyles(styles)(CgResults);
